import getGraphQlClient from '~graphql/getGraphQlClient';
import { CREATE_ANNUNCIO_FUNEBRE } from '~graphql/queries/necrologi';

export default async function createAnnuncioFunebre(fields) {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    mutation: CREATE_ANNUNCIO_FUNEBRE,
    variables: { fields },
  });

  return response.data.createAnnunci_funebri.annunci_funebri.objectId;
}
